module.exports = __webpack_public_path__ + "static/image2-9a35fa952aa36f4c931983468dd1af76.jpg";